import { render, staticRenderFns } from "./UserJoin.vue?vue&type=template&id=05bd4c69&scoped=true";
import script from "./UserJoin.vue?vue&type=script&lang=js";
export * from "./UserJoin.vue?vue&type=script&lang=js";
import style0 from "./UserJoin.vue?vue&type=style&index=0&id=05bd4c69&prod&lang=css";
import style1 from "./UserJoin.vue?vue&type=style&index=1&id=05bd4c69&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "05bd4c69", null);
export default component.exports;